import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import {
  currencySymbol,
  currencySymbolDirectFromCountry,
} from '../../../../../utils/DynamicForms';
import { CurrencyInput } from '../../../../../controls/CurrencyInput';
import { FormItem } from '../../../../../controls/FormItem';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';
import { delay, get } from 'lodash';
import { useDynamicFormContext } from '../../../DynamicFormContext';

const CurrencyControl = ({
  path,
  label,
  data,
  handleChange,
  handleRemove,
  handleBlur,
  uischema,
  schema,
  formData,
  required,
  disabled,
  optionalMessage
}: FieldProps) => {
  const { handleActions } = useDynamicFormContext()

  const currency =
    currencySymbol(formData, uischema.options?.dependencies?.[0]) ||
    currencySymbolDirectFromCountry(uischema.options?.dependencies?.[0]);

  const moreInfo = uischema.options?.moreInfo;
  const dependentValue = uischema.options?.dependentValue;
  const changedValue = uischema.options?.changedValue;
  const changePath = uischema.options?.changePath;

  const percentageDifference = (a: any, b: any) => {
    return 100 - ((a / b) * 100);
  }

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-text-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <div>
        <CurrencyInput
          currencySymbol={currency}
          value={data}
          onBlur={(val) => {
            delay(() => {
              if (changePath)
                handleChange(
                  changePath,
                  true,
                );
            }, 1000);
            handleBlur(path);
          }}
          onChange={(value) => {
            if (!!value) {
              handleChange(
                path,
                value.charAt(value.length - 1) === '.' ? value : Number(value),
              );
            } else {
              handleRemove(path);
            }
            if (changePath && !get(formData, changePath)) {
              handleChange(
                changePath,
                true,
              );

              delay(() => {
                handleBlur(changePath);
              }, 1000)
            }

            if (dependentValue) {
              const diff = percentageDifference(parseInt(value), parseInt(get(formData, dependentValue)));
              if (Math.abs(diff) > 37)
                handleActions([
                  {
                    key: 'mutate',
                    data: [{ path: changedValue, value: true }]
                  }
                ])

              else handleActions([
                {
                  key: 'mutate',
                  data: [{ path: changedValue, value: false }]
                }
              ])
            }
          }}
          disabled={disabled}
        />
        {schema.description && (
          <p className="description margin-bottom">{schema.description}</p>
        )}
      </div>
    </FormItem>
  );
};

export const CurrencyInputControlEntry = {
  tester: rankWith(2, uiTypeIs('Currency')),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(CurrencyControl)),
};
